const useErrorHandler = () => {
  return (error: any, setError: Function) => {
    if (error?.data?.errors) {
      Object.entries<Record<number, string>>(error?.data?.errors)
        .map(([field, errors]) => setError(field, { message: errors[0] }))
    } else {
      throw error
    }
  }
}

export default useErrorHandler
